<template>
<div class="subject-model">
    <div class="model-head">
        <div class="title" v-if="info.title.length>0">{{info.title}}</div>
        <div class="tab">
            <div class="type-item" :class="{active:type == 0}" @click="tabChange(0)">推荐</div>
            <div class="type-item" :class="{active:type == 1}" @click="tabChange(1)">最新</div>
            
        </div>
    </div>
    <!-- <div class="title" v-if="info.title.length>0">{{info.title}}</div>
    <div class="tab">
        <div class="flex-cont">
            <div class="type-item" :class="{active:type == 1}" @click="tabChange(1)">推荐</div>
            <div class="type-item" :class="{active:type == 2}" @click="tabChange(2)">最新</div>
        </div>
        <a v-if="detail.closed == 0" class="join-subject" @click="postLink($event)" :href="'/publish/dining?subject='+params.id|hostBuild('forum')" target="_blank"><i class="el-icon-edit"></i> 参与话题</a>
    </div> -->
    <div class="post-cont">
        <template v-for="(item,index) in list">
            <YorkbbsInfoflowItem v-if="item.app === 'crm_ad'" :data="item" :key="index"></YorkbbsInfoflowItem>
            <SubjectCmsItem :data="item" :key="item.id" v-if="item.app == 'cms_post'" />
            <SubjectPostItem :data="item" :key="item.id" v-if="item.app == 'bbs_post'" :imgType="info.imgType" @attention="attention" />
        </template>
        <div class="loading-style" v-if="hasMore && listLoading " ><i class="el-icon-loading"></i> 加载中</div>
        <div class="loading-style" v-if="!hasMore" >没有更多了</div>
    </div>
</div>
</template>
<script>
import YorkbbsInfoflowItem from '@/common/item-infoflow.vue'
import SubjectCmsItem from './subject-cms-item.vue'
import SubjectPostItem from './subject-post-item.vue'
import { isScrollToPageBottom ,inflowAdvConvert} from '@/utils/utils';
import { throttle } from 'throttle-debounce';
export default {
    name:'SubjectModel',
    components:{YorkbbsInfoflowItem,SubjectCmsItem,SubjectPostItem},
    props:['info'],
    data(){
        return {
            params:{
                subjectIds:[],
                dataOrigin:[],
                offset:1,
                size:10,
            },
            detail:{},
            list:[],
            type:1,
            pageComplete:false,
            hasMore:true,
            listLoading:true,
        }
    },
    created(){
        this.params.subjectIds = this.info.subjectIds;
        this.params.dataOrigin = this.info.dataOrigin;
        this.type = this.info.defaultList ||0 ;
        this.getList();
    },
    mounted() {
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('scroll', this.pageScroll);
        });
    },
    methods:{
        tabChange(index){
            if( this.type == index) return false;
            this.pageComplete = false;
            this.type = index;
            this.params.offset = 1;
            this.getList();
        },
        async getList(){
            this.listLoading = true;
            
            if( this.params.offset == 1 ){
                this.list = [];
            }
            if( this.type == 0 ){
                let result = await this.$axios.post('/subject/v1/post/list/recommended/for/special',this.params);
    
                let inflowAdv = inflowAdvConvert(result.data.items, 'subject', this.params.id);
                this.list = this.list.concat(inflowAdv);
                this.hasMore = this.list.length < result.data.itemTotal;
                this.detail.postCount = result.data.itemTotal;
       
            }else{
                let result = await this.$axios.post('/subject/v1/post/list/latest/for/special',this.params);
                let inflowAdv = inflowAdvConvert(result.data.items, 'subject', this.params.id);
                this.list = this.list.concat(inflowAdv);
                this.hasMore = this.list.length < result.data.itemTotal;
             
            }
           

            this.pageComplete = true;
            this.listLoading = false;
        },
        pageScroll: throttle(300, function () {
            if( isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading ){
                this.params.offset ++;
                this.getList();
            }
        }),
        attention(obj){
           
            for(var i=0; i<this.list.length;i++){
                if(this.list[i].app != 'bbs_post') continue;
                if( this.list[i].user.id == obj.id){
                    this.list[i].user.focusedByMe = obj.val;
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.subject-model{
    .model-head{
        display:flex;
        .title{flex:1;}
    }
    .title{font-size: 20px; line-height: 24px; font-weight: bold; margin-bottom: 30px;}
    .tab{ 
        display: flex; align-items: center; margin-bottom: 30px;
        .type-item{
            font-size: 18px; line-height: 24px; color: #999; margin-right: 30px; user-select: none; cursor: pointer;
            &.active{font-size: 20px; line-height: 28px; color: #111; font-weight: bold;}
        }
        .join-subject{
            display: flex; align-items: center; height: 36px; background: #e43a3a; color: #fff; font-size: 14px; border-radius: 4px; padding: 0 10px; user-select: none; cursor: pointer;
            i{margin-right: 3px;}
            &:hover{opacity: 0.8;}
        }
    }

    .post-cont{
        ::v-deep{
            .flex-cont{flex:1;overflow: hidden;}
        }
    }
    .loading-style{display: flex; margin-bottom: 20px; color: #999; justify-content: center ; align-items: center; font-size: 12px;
    i{margin-right: 5px;}
}
}
</style>